import { defineComponent, h } from 'vue';
import BaseComponent from './BaseComponentMixin.jsx';
import EventBus from '../event-bus.js';
import { QExpansionItem } from 'quasar';

import utils from '../../Shared/utils.jsx';
import methods from '../../Shared/methods';

export default defineComponent({
    name: 'accordion-group',
    mixins: [BaseComponent],
    components: {
        QExpansionItem,
    },
    emits: ['close','open','update:isOpen'],
    data: function () {
        return {
            hideHeaderBarEval: null,
            groupTitleEval: null,
            initialIsOpenEval: null
        }
    },
    props: {
        value: null,
        isOpen: {
            type: Boolean,
            required: false,
        },
    },
    computed: {
        hideHeaderBar() {
            try {
                if(this.hideHeaderBarEval === null && this.controlData.HideHeaderBar)
                    this.hideHeaderBarEval = utils.compileObject(this, this.controlData.HideHeaderBar);
                if(this.hideHeaderBarEval)
                    return utils.evaluateObject(this.hideHeaderBarEval, this) == true;
                return false;
            }
            catch (e) {
                utils.warn('HideHeaderBar could not evaluate expression: ' + this.controlData.HideHeaderBar + '; ' + e);
                return false;
            }
        },
        groupTitle() {
            try {
                if(this.groupTitleEval === null && this.controlData.GroupTitle)
                    this.groupTitleEval = utils.compile(this, this.controlData.GroupTitle);
                if(this.groupTitleEval)
                    return utils.evaluate(this.groupTitleEval, this);
                return '';
            }
            catch (e) {
                utils.warn('GroupTitle could not evaluate expression: ' + this.controlData.GroupTitle + '; ' + e);
                return '';
            }
        },
        initialIsOpen() {
            try {
                if(this.initialIsOpenEval === null && this.controlData.IsOpen)
                    this.initialIsOpenEval = utils.compileObject(this, this.controlData.IsOpen);
                if(this.initialIsOpenEval)
                    return utils.evaluateObject(this.initialIsOpenEval, this) == true;
                return false;
            }
            catch (e) {
                utils.warn('IsOpen could not evaluate expression: ' + this.controlData.IsOpen + '; ' + e);
                return false;
            }
        },
        resolvedIsOpen() {
            return typeof this.$props.isOpen === 'boolean' ? this.$props.isOpen : this.initialIsOpen;
        }
    },
    created() {
        utils.debug(`AccordionGroup created`);
    },
    //Mounted Replaced with preRenderComplete
    methods: {
        onModelUpdate(isOpen) {
            this.$emit('update:isOpen', isOpen);
            if (isOpen)
                this.$emit('open');
            else
                this.$emit('close');
        },
        Close() {
            this.$emit('update:isOpen', false);
            this.$emit('close');
        },
        Open() {
            this.$emit('update:isOpen', true);
            this.$emit('open');
        },
        ToggleIsOpen() {
            this.$emit('update:isOpen', !this.resolvedIsOpen);
        },
        preRenderComplete() {
            this.finishRenderHandler(this);
        }
    },
    render() {
        try {
            let slots = {};

            // Creating the header bar
            if (!this.hideHeaderBar) {
                utils.debug(`AccordionGroup render in if(!this.hideHeaderBar)`);

                // The title can have pre title controls, a title, and header controls. We have to figure out which ones we have and 
                // render them accordingly. We're going to wrap everything in the expansion panel header, and in a div that will emulate a 
                // horizontal layout
                let titleContent = [];
    
                const finishedRender = { onFinishedRender: (item) => this.finishRenderHandler(item) };

                if(this.controlData?.PreTitleControls?.length)
                    titleContent.push(<div class="c-StackContent-header row items-center no-wrap q-mr-sm">{utils.generateItemsFromArray(h, this, this.controlData.PreTitleControls, null, 'HorizontalLayout', finishedRender)}</div>);
    
                if(this.groupTitle)
                    titleContent.push(<div class="q-mr-sm">{this.groupTitle}</div>);
    
                if(this.controlData?.HeaderControls?.length)
                    titleContent.push(<div class="c-StackContent-header row items-center no-wrap q-mr-sm">{utils.generateItemsFromArray(h, this, this.controlData.HeaderControls, null, 'HorizontalLayout', finishedRender)}</div>);
    
                slots.header = () => (
                    <div class="row items-center no-wrap full-width">
                        {titleContent}
                    </div>
                );
            }
    
            if (this.controlData.AccordionBody) {
                utils.debug(`AccordionGroup render in if(this.controlData.AccordionBody)`);

                let body = utils.generateItemsFromArray(h, this, this.controlData.AccordionBody, null, 'VerticalLayout', { onFinishedRender: (item) => this.finishRenderHandler(item) });
    
                slots.default = () => (
                    <div class="column">
                        {body}
                    </div>
                );
            }
    
            return (
                <QExpansionItem
                    modelValue={this.resolvedIsOpen}
                    onUpdate:modelValue={this.onModelUpdate}
                    hideExpandIcon={this.hideHeaderBar}
                    expandIcon="keyboard_arrow_down"
                    headerStyle={this.hideHeaderBar ? 'display: none;' : undefined}
                    class={{ 'c-AccordionGroup': true, [`c-name-${this.name || 'unnamed'}`]: true }}
                >
                    {slots}
                </QExpansionItem>
            );
        }
        catch(e) {
            utils.error('AccordionGroup Render failed', e);
            return <div>AccordionGroup Failed to Render {e}</div>;
        }
    }
});